const map = {
	"./bugreport.json": 49280,
	"./careprovider.json": 85536,
	"./common.json": 36709,
	"./contact.json": 48108,
	"./forms.json": 61815,
	"./imprint.json": 15265,
	"./infrastructure.json": 34375,
	"./population.json": 23895,
	"./privacy.json": 52944,
	"./privatemenu.json": 85748,
	"./profile.json": 72809,
	"./register.json": 15485,
	"./scenarios.json": 1547,
	"./services.json": 22872,
	"./team.json": 88053
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 41251;